import React, { useEffect, useMemo, useState } from "react";
import "./header.css";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Avatar from "@mui/material/Avatar";
import Offcanvas from "react-bootstrap/Offcanvas";
import MyProfile from "../../MyProfile/MyProfile";
import { Popup } from "semantic-ui-react";
import ProfilePopup from "../profilePopUp/ProfilePopup";
import axios from "../../axios";
import { IP } from "../../internalServer";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import assets from "../../assets/assets";
import ActiveMenuEnum from "../../Enum/ActiveMenuEnum";
import { Bell } from "lucide-react";
import { setActiveMenu } from "../../redux/PageSlice";

// const Headers = localStorage.getItem("Header");
// let classTeacherArray = [];
// let coodinatorArray = [];
// let subjectTeacherArray = [];
function Header({
  jsonRole_CTinformation,
  jsonRole_Coinformation,
  jsonRole_Geinformation,
}) {
  const Teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [subItem, setSubItem] = useState(false);
  const [hwSubMenue, sethwSubMenue] = useState(false);
  const [data] = React.useState(null);
  const [profile, setProfile] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  const Headers = useSelector((stage) => stage.pageSlice.activeMenu);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [classTeacherArray, setClassTeacherArray] = useState([]);
  const [classTeacherWithSubjects, setClassTeacherWithSubjects] = useState([]);
  const [coodinatorArray, setCoodinatorArray] = useState([]);
  const [subjectTeacherArray, setSubjectTeacherArray] = useState([]);

  const getTeacher = async () => {
    try {
      const res = await axios.get(`/api/v1/school/teacher/get/${Teacher_id}`);
      if (res && res.data.data) {
        setUserInfo(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching teacher data:", error);
    }
  };
  useEffect(() => {
    console.log("teacher id in header usedefect called");
    if (Teacher_id !== null) {
      getTeacher();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Teacher_id]);
  const navigate = useNavigate();

  const handelExpendBtn = () => {
    if (subItem) {
      setSubItem(false);
    } else {
      setSubItem(true);
    }
  };
  const handelExpendHW = () => {
    if (hwSubMenue) {
      sethwSubMenue(false);
    } else {
      sethwSubMenue(true);
    }
  };

  const classTeacher = () => {
    const ctArray = []; // normal class-teacher
    const ctWithSubjects = []; // class-teacher with subjects

    jsonRole_CTinformation?.forEach((item) => {
      if (item.is_class_teacher) {
        const std = item.standard_id?.name;
        const sec = item.section_id?.name;

        if (std && sec) {
          // Normal class teacher list
          ctArray.push(`${std}-${sec}`);

          // Subjects array
          const subjects =
            item.subjects_id?.map((sub) => sub?.name).filter(Boolean) || [];

          // 👉 Push only if subjects exist
          if (subjects.length > 0) {
            ctWithSubjects.push({
              classSection: `${std}-${sec}`,
              subjects,
            });
          }
        }
      }
    });

    setClassTeacherArray(ctArray);
    setClassTeacherWithSubjects(ctWithSubjects);
  };

  const cordinator = () => {
    const coArray = [];
    jsonRole_Coinformation?.map((item) => {
      if (item.is_class_co_ordinator) {
        const std = item.standard_id?.name;
        const sec = item.section_id?.name;
        if (std && sec) {
          coArray.push(`${std}-${sec}`);
        }
      }
    });
    setCoodinatorArray(coArray);
  };

  const subjTeacher = () => {
    const subArray = [];
    jsonRole_Geinformation?.map((item) => {
      const std = item.standard_id?.name;
      const sec = item.section_id?.name;
      item?.subjects_id?.forEach((obj) => {
        const sub = obj?.name;
        if (std && sec && sub) {
          subArray.push(`${std}-${sec} (${sub})`);
        }
      });
    });
    setSubjectTeacherArray(subArray);
  };

  return (
    <>
      <Navbar bg="white" expand="lg" className="">
        <Container className="m-1" fluid>
          <img className="Logo" src="/images/logo.png" alt="" />
          <span className="Assesment_Tag" style={{ color: "#f77f00" }}>
            <div className="d-flex align-items-center">
              <span>
                {Headers === ActiveMenuEnum.DSM && (
                  <img
                    src={assets?.CalendarImg}
                    alt="icon"
                    style={{
                      width: "45px",
                      height: "47px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.ASSESSMENT && (
                  <img
                    src={assets?.AssessmentImg}
                    alt="icon"
                    style={{
                      width: "45px",
                      height: "47px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.LM && (
                  <img
                    src={assets?.CalendarImg}
                    alt="icon"
                    style={{
                      width: "45px",
                      height: "47px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.CL && (
                  <img
                    src={assets?.CalendarImg}
                    alt="icon"
                    style={{
                      width: "45px",
                      height: "47px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.QL && (
                  <img
                    src={assets?.CalendarImg}
                    alt="icon"
                    style={{
                      width: "45px",
                      height: "47px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.HM && (
                  <img
                    src={assets?.HomeworkImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.PR && (
                  <img
                    src={assets?.PreReadImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.ACTIVITY && (
                  <img
                    src={assets?.ActivityImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "15px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.COMMUNITY && (
                  <img
                    src={assets?.CommunityImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.STUDENT_QUERY && (
                  <img
                    src={assets?.QueryImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.PERFORMANCE && (
                  <img
                    src={assets?.AssessmentImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.SP && (
                  <img
                    src={assets?.AssessmentImg}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
                {Headers === ActiveMenuEnum.REPORT_CARD && (
                  <img
                    src={assets?.ReportCardIcon}
                    alt="icon"
                    style={{
                      width: "55px",
                      height: "55px",
                      marginRight: "20px",
                    }}
                  />
                )}
              </span>
              <span>{Headers}</span>
            </div>
          </span>
          <div
            className="schoolDetails d-flex align-items-center justify-content-center"
            style={{ opacity: "0.6" }}
          >
            <div className="schoolLogo">
              <img
                style={{ width: "60px", height: "60px", marginRight: "8px" }}
                src={
                  userInfo?.school?.profile_pic
                    ? IP + userInfo?.school?.profile_pic
                    : "/images/default_school_logo.jpg"
                }
                alt="schoolLogo"
              />
            </div>
            <div className="schoolName">
              <div
                style={{
                  fontSize: "22px",
                  fontWeight: "700",
                  color: "#596ce8",
                }}
              >
                {userInfo?.school?.name}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  fontStyle: "italic",
                  textAlign: "right",
                }}
              >
                Powered by XploreSense™
              </div>
            </div>
          </div>

          <div className="Right_Bar">
            <div
              onClick={() => {
                navigate("/feature-guide");
              }}
              className="done"
            >
              <img
                src="/images/user_guide_feature_b4s.png"
                alt="icon"
                style={{ width: "30px", height: "35px", cursor: "pointer" }}
              />
            </div>
            <Popup
              on="click"
              popperDependencies={[!!data]}
              open={isPopupOpen}
              onOpen={() => {
                setIsPopupOpen(true);
              }}
              onClose={() => {
                setIsPopupOpen(false);
              }}
              trigger={
                <img
                  src={
                    userInfo?.profile_picture
                      ? IP + userInfo?.profile_picture.replace(/^\./, "")
                      : userInfo?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : userInfo?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default-profile.png"
                  }
                  alt="icon"
                  className="profilePicImg"
                  style={{
                    width: "45px",
                    height: "43px",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onError={(e) => {
                    // This function will run if the image fails to load
                    if (userInfo?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg";
                    } else if (userInfo?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png";
                    } else {
                      e.target.src = "/images/default-profile.png";
                    }
                  }}
                />
              }
              wide
            >
              {data === null ? (
                <div>
                  <ProfilePopup
                    setIsPopupOpen={setIsPopupOpen}
                    setProfile={setProfile}
                    userInfo={userInfo}
                    subjectTeacherArray={subjectTeacherArray}
                    coodinatorArray={coodinatorArray}
                    classTeacherArray={classTeacherArray}
                  />
                </div>
              ) : (
                <></>
              )}
            </Popup>
          </div>
        </Container>
      </Navbar>
      <hr style={{ marginTop: "0px", marginBottom: "2px" }} />
      {userInfo && profile && (
        <MyProfile
          setProfile={setProfile}
          profile={profile}
          userInfo={userInfo}
          subjectTeacherArray={subjectTeacherArray}
          coodinatorArray={coodinatorArray}
          classTeacherArray={classTeacherArray}
          classTeacherWithSubjects={classTeacherWithSubjects}
          subjTeacher={subjTeacher}
          cordinator={cordinator}
          classTeacher={classTeacher}
        />
      )}
    </>
  );
}

export default Header;
